import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv'
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatTableDataSource, MatDialog, MatPaginator, MatSort } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { first } from 'rxjs/operators';
import { WebConstants } from 'src/app/util/web.constants';
import { TokenStorage } from 'src/app/util/token.storage';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { ExcelExportDataService } from 'src/app/excelService/excel-export-data.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})
export class ConfigurationComponent implements OnInit {

  public displayedColumns: string[] = [
    'date',
    'amount',
    'actions'
  ];

  options = {
    fieldSeparator: ',',
    quoteStrings: '',
    decimalseparator: '.',
    showLabels: true,
    showTitle: false,
    useBom: true,
    headers: ['LicensePlate', 'VehicleOwner', 'State', 'Country', 'Zone']
  };

  public ticketPriceForm: any;
  public dataSource = new MatTableDataSource();
  public lprCameraGroups: any[] = null;
  public updateMode: boolean = false;
  public updateId: number = null;
  public data: [] = [];
  sampleData: any;
  public zoneData: any;
  public tempId: any;
  public title: string = WebConstants.MENU_NAMES.CONFIGURATION;
  public titleTicketPrice: string = "Ticket Price";

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    public configurationService: ConfigurationService,
    public excelExportDataService: ExcelExportDataService,
    public toastrService: ToastrService,
    public dialog: MatDialog,
    public tokenStorage: TokenStorage,
    public datePipe: DatePipe,) {

    this.ticketPriceForm = new FormGroup({
      date: new FormControl("", Validators.required),
      amount: new FormControl("", Validators.required),
    });
  }

  ngOnInit(): void {
    console.log("Configuration Screen");
    this.getAllTicketPrice();
  }

  getTempId(obj: any){
    this.tempId = obj;
  }

  
  getZoneName(zone){
    let myObj = this.zoneData.filter(x=>x.zoneId == zone.zone)[0];
    // console.log(myObj);
    let myZone = Object.assign({},myObj);
    return myZone.zoneName;
  }

  getAllTicketPrice() {
    this.configurationService.getAllTicketPrice()
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.data = response.data;
          this.dataSource = new MatTableDataSource<unknown>(this.data);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
        else {
          this.toastrService.error(response.value, "Failed To Load Data!");
        }
      });
  }

  addTicketPrice() {
    let rawData = this.ticketPriceForm.value;
    rawData.date = + new Date (rawData.date);
    rawData.month = new Date (rawData.date).getMonth() + 1;
    rawData.year = new Date (rawData.date).getFullYear();

    if(rawData.amount < 0){
      this.toastrService.error("Please Enter A Valid Amount", "Failed To Add Data!");
      return;
    }

    this.configurationService.addTicketPrice(rawData)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Data Added Successfully!");
          this.getAllTicketPrice();
          this.ticketPriceForm.reset();
        } else {
          this.toastrService.error(response.value, "Failed To Add Data!");
        }
      });
  }

  resetForm(){
    this.ticketPriceForm.reset();
    this.updateMode = false;
  }

  sampleCSV() {
    this.sampleData = [
      {
        numberPlate: "JKL1243",
        vehicleOwner: "John",
        state: "GA",
        country: "US",
        zone: 4413,
        // vin: "JN3MS337A9PW202929",
        // address: "GA; US",
      },
      {
        numberPlate: "PFL1353",
        vehicleOwner: "Wick",
        state: "GA",
        country: "US",
        zone: 4413,
        // vin: "JN3MS337A9PW202929",
        // address: "GA; US",
      },
      {
        numberPlate: "KOL1443",
        vehicleOwner: "Cena",
        state: "FL",
        country: "US",
        zone: 4413,
        // vin: "JN3MS337A9PW202929",
        // address: "GA; US",
      },
    ];

    new AngularCsv(this.sampleData, "SampleCSV", this.options);
  }

  deleteTicketPrice(obj: any) {
    this.configurationService.deleteTicketPrice(obj.id)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Data Deleted Successfully!");
          this.getAllTicketPrice();
          this.resetForm();

        } else {
          this.toastrService.error(response.value, "Failed To Delete Data!")
        }
      });
  }

  setUpdateMode(obj: any) {
    this.updateMode = true;
    this.updateId = obj.id;

    let date = this.getDateWithFormat(new Date(obj.date), WebConstants.DATE.FORMAT_YYYY_MM_DD);

    this.ticketPriceForm.controls["date"].setValue(date);
    this.ticketPriceForm.controls["amount"].setValue(obj.amount);
  }

  updateLprWhiteList() {
    let rawData = this.ticketPriceForm.value;
    rawData.id = this.updateId;
    rawData.date = + new Date (rawData.date);
    rawData.month = new Date (rawData.date).getMonth() + 1;
    rawData.year = new Date (rawData.date).getFullYear();

    this.configurationService.updateTicketPrice(rawData)
      .pipe(first())
      .subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Data Updated Successfully!");
          this.getAllTicketPrice();
          this.ticketPriceForm.reset();
          this.updateMode = false;
        } 
        else {
          this.toastrService.error(response.value, "Failed To Update Data!")
        }
      });
  }

  excelSheetDownload() {
    let dataForExcel = [];

    this.data.forEach((row: any) => {
      let rowData: any = [row.numberPlate, row.vehicleOwner==null ? "":row.vehicleOwner, row.state==null ? "":row.state, row.country==null ? "":row.country, row.zone==null ? "":row.zone==0 ? "":this.getZoneName(row) + " " + row.zone]
      dataForExcel.push(rowData);
    });

    let reportData = {
      title: this.title,
      data: dataForExcel,
      headers: ['LicensePlate' ,'VehicleOwner', 'State', 'Country', 'Zone']
    };

    // this.excelExportDataService.exportExcel(reportData)
    
    new AngularCsv(dataForExcel, this.title, this.options);
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLocaleLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  getDateWithFormat(date: any, format: any): any {
    return this.datePipe.transform(date, format);
  }

}
